import Axios from "axios";
import { SET_SALES_ACTION_LIST, UNSET_SALES_ACTION_LIST } from "@/store/mutation-types";
import { saveUpdateSalesLeadAction, getSalesLeadAction } from "@/store/api";
// initial state
const state = {
    getSalesLeadAction: [],
    editingSalesLeadAction: null,
};

const getters = {
    getSalesLeadAction(state) {
        return state.getSalesLeadAction;
    },
    getEditingSalesLeadAction: (state) => state.editingSalesLeadAction,
};

const mutations = {
    [SET_SALES_ACTION_LIST](state, data) {
        state.getSalesLeadAction = data;
    },
    [UNSET_SALES_ACTION_LIST](state) {
        state.getSalesLeadAction = [];
    },
    setEditingSalesLeadAction(state, lead) {
        state.editingSalesLeadAction = lead;
    },
};

const actions = {
    saveUpdateSalesLeadAction({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateSalesLeadAction, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getSalesLeadAction({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getSalesLeadAction, data)
                .then(function (response) {
                    commit("SET_SALES_ACTION_LIST", response.data.data);
                    resolve(response);
                })
                .catch(function (error) {
                    commit("UNSET_SALES_ACTION_LIST");
                    reject(error);
                })
                .then((always) => { });
        });
    },

    getSalesLeadActionById({ commit }, data) {
        const getSalesLeadActionById = `${getSalesLeadAction}/${data}`;
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.get(getSalesLeadActionById)
                .then((response) => {
                    resolve(response.data.code);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
